import React from 'react';
import PropTypes from 'prop-types';

import ResourceWeeklySchedule from '../ResourceSchedule/ResourceWeeklySchedule';
import userAxis from './userAxis';
import useUserRows from './useUserRows';

export default function UserWeeklySchedule({ filters, ...props }) {
  const rows = useUserRows({ selectedUsers: filters.users });
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ResourceWeeklySchedule axis={userAxis} rows={rows} {...props} />
  );
}

UserWeeklySchedule.propTypes = {
  filters: PropTypes.shape({
    users: PropTypes.arrayOf(PropTypes.string),
  }),
};

UserWeeklySchedule.defaultProps = {
  filters: {},
};
